import { ServiceComboEditMode } from "@/Administration/Models/UI/Enums/Administration";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { ServiceComboItemType } from "@/Common/Models/Services/Enums/ServiceComboItemType";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IEditServiceComponentProps } from "./EditServiceComponent";

class EditPortalDetailsComponentState {
    public OnlineNameFR: string;
    public OnlineNameEN: string;
    public OnlineNameES: string;

    public OnlineDescriptionFR: string;
    public OnlineDescriptionEN: string;
    public OnlineDescriptionES: string;

    public OnlineDisclaimerFR: string;
    public OnlineDisclaimerEN: string;
    public OnlineDisclaimerES: string;
}

class EditOnlineDetailsComponent extends React.Component<IEditServiceComponentProps, EditPortalDetailsComponentState> {
    private id = "serviceOnlineDetails";

    constructor(props: IEditServiceComponentProps) {
        super(props);
        const initialState = new EditPortalDetailsComponentState();

        const definitionModel = props.baseDefinitionModel;

        const onlineNameLookup = IsNullOrWhiteSpace(definitionModel.OnlineNameLookupId) ? null : cacheStore.GetLookupById(definitionModel.OnlineNameLookupId);
        initialState.OnlineNameEN = onlineNameLookup != null ? onlineNameLookup.en : "";
        initialState.OnlineNameFR = onlineNameLookup != null ? onlineNameLookup.fr : "";
        initialState.OnlineNameES = onlineNameLookup != null ? onlineNameLookup.esMX : "";

        const onlineDescriptionLookup = IsNullOrWhiteSpace(definitionModel.OnlineDescriptionLookupId) ? null : cacheStore.GetLookupById(definitionModel.OnlineDescriptionLookupId);
        initialState.OnlineDescriptionEN = onlineDescriptionLookup != null ? onlineDescriptionLookup.en : "";
        initialState.OnlineDescriptionFR = onlineDescriptionLookup != null ? onlineDescriptionLookup.fr : "";
        initialState.OnlineDescriptionES = onlineDescriptionLookup != null ? onlineDescriptionLookup.esMX : "";

        const onlineDisclaimerLookup = IsNullOrWhiteSpace(definitionModel.OnlineDisclaimerLookupId) ? null : cacheStore.GetLookupById(definitionModel.OnlineDisclaimerLookupId);
        initialState.OnlineDisclaimerEN = onlineDisclaimerLookup != null ? onlineDisclaimerLookup.en : "";
        initialState.OnlineDisclaimerFR = onlineDisclaimerLookup != null ? onlineDisclaimerLookup.fr : "";
        initialState.OnlineDisclaimerES = onlineDisclaimerLookup != null ? onlineDisclaimerLookup.esMX : "";

        this.state = initialState;
    }

    public componentDidMount(): void {
        let elem = $("#" + this.id);
        let cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".p-header",
            stop: function() {
                elem.draggable("destroy");
                window.setTimeout(() => elem.draggable(dragOptions), 80);
            }
        };
        elem.draggable(dragOptions);

        autosize(document.getElementById("portalDescEN"));
        autosize(document.getElementById("portalDescFR"));
        autosize(document.getElementById("portalDescES"));
    }

    public render(): JSX.Element {
        // get proper title
        let title: string = "";
        if (this.props.currentEditedType == ServiceComboItemType.Service) {
            if (this.props.currentEditMode == ServiceComboEditMode.Edit)
                title = cacheStore.GetString("EditServiceLabel");
            if (this.props.currentEditMode == ServiceComboEditMode.Create)
                title = cacheStore.GetString("AddServiceLabel");
        }
        if (this.props.currentEditedType == ServiceComboItemType.Combo) {
            if (this.props.currentEditMode == ServiceComboEditMode.Edit)
                title = cacheStore.GetString("EditComboLabel");
            if (this.props.currentEditMode == ServiceComboEditMode.Create)
                title = cacheStore.GetString("AddComboLabel");
        }

        title += " : " + cacheStore.GetString("PortalConfigurationLabel");

        let self = this;
        let state = this.state;

        return (
            <div className="request-popup popup-services" id={this.id}>
                <div className="p-header ui-draggable-handle">
                    <a className="close" onClick={this.onCancelClick.bind(this)}>x</a>
                    <h3 className="uppercase">{title}</h3>
                </div>

                <div className="p-body" style={{ overflowY: "auto" }}>
                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalNameENLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={state.OnlineNameEN}
                                onChange={val => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineNameEN = val;
                                    self.setState(s);
                                }}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalNameFRLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={state.OnlineNameFR}
                                onChange={val => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineNameFR = val;
                                    self.setState(s);
                                }}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-15">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalNameESLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <TextboxControl
                                debounceMs={200}
                                value={state.OnlineNameES}
                                onChange={val => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineNameES = val;
                                    self.setState(s);
                                }}
                                style={{ marginRight: "10px" }}
                                className="form-control"
                                placeholder=""
                                id="txtNameEN"
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDesrciptionENLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDescEN"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDescriptionEN}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDescriptionEN = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDesrciptionFRLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDescFR"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDescriptionFR}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDescriptionFR = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-15">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDesrciptionESLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDescES"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDescriptionES}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDescriptionES = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDisclaimerENLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDiscEN"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDisclaimerEN}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDisclaimerEN = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDisclaimerFRLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDiscFR"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDisclaimerFR}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDisclaimerFR = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                    <div className="popup-services-flex bottom-5">
                        <div className="service-left-label-col">
                            <div className="divLabel"><label className="no-margin">{cacheStore.GetString("PortalDisclaimerESLabel")}</label></div>
                        </div>
                        <div className="service-right-col">
                            <textarea
                                id="portalDiscES"
                                className="form-control"
                                rows={2}
                                value={state.OnlineDisclaimerES}
                                onChange={(e: any) => {
                                    let s = new EditPortalDetailsComponentState();
                                    s.OnlineDisclaimerES = e.target.value;
                                    self.setState(s);
                                }}
                            />
                        </div>
                    </div>

                </div>

                <div className="p-footer" style={{ "marginTop": "20px" }}>
                    <div className="popup-services space-between">
                        <div className="popup-services-flex flex-end ">
                            <ButtonGroup spacing="sm">
                                <ButtonControl
                                    className="btn btn-default"
                                    onClick={this.onCancelClick.bind(this)}
                                    label={cacheStore.GetString("CancelLabel")}
                                />
                                <ButtonControl
                                    variant="brand"
                                    onClick={this.onSaveClick.bind(this)}
                                    label={cacheStore.GetString("SaveLabel")}
                                />
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private onSaveClick(): void {
        if (this.props.baseDefinitionModel instanceof ServiceDefinitionModel) {
            this.saveServiceDefinition();
        }
        else if (this.props.baseDefinitionModel instanceof ServiceComboDefinitionModel) {
            this.saveComboDefinition();
        }
    }

    private onCancelClick(): void {
        if (this.props.onCloseOperation != null) {
            var operation = new LocalEvent(this.props.onCloseOperation);
            LocalEventDispatcher.dispatch(operation);
        }
    }

    private saveServiceDefinition(): void {
        var serviceDefinitionModel = this.props.baseDefinitionModel as ServiceDefinitionModel;

        serviceDefinitionModel.OnlineNameEN = this.state.OnlineNameEN;
        serviceDefinitionModel.OnlineNameFR = this.state.OnlineNameFR;
        serviceDefinitionModel.OnlineNameES = this.state.OnlineNameES;
        serviceDefinitionModel.OnlineDescriptionEN = this.state.OnlineDescriptionEN;
        serviceDefinitionModel.OnlineDescriptionFR = this.state.OnlineDescriptionFR;
        serviceDefinitionModel.OnlineDescriptionES = this.state.OnlineDescriptionES;
        serviceDefinitionModel.OnlineDisclaimerEN = this.state.OnlineDisclaimerEN;
        serviceDefinitionModel.OnlineDisclaimerFR = this.state.OnlineDisclaimerFR;
        serviceDefinitionModel.OnlineDisclaimerES = this.state.OnlineDisclaimerES;

        var operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SaveService_Click);
        operation.AddItem("serviceDefinition", serviceDefinitionModel);
        operation.AddItem("isSavingOnlineInfo", true);
        LocalEventDispatcher.dispatch(operation);
    }

    private saveComboDefinition(): void {
        var comboModel = this.props.baseDefinitionModel as ServiceComboDefinitionModel;

        comboModel.OnlineNameEN = this.state.OnlineNameEN;
        comboModel.OnlineNameFR = this.state.OnlineNameFR;
        comboModel.OnlineNameES = this.state.OnlineNameES;
        comboModel.OnlineDescriptionEN = this.state.OnlineDescriptionEN;
        comboModel.OnlineDescriptionFR = this.state.OnlineDescriptionFR;
        comboModel.OnlineDescriptionES = this.state.OnlineDescriptionES;
        comboModel.OnlineDisclaimerEN = this.state.OnlineDisclaimerEN;
        comboModel.OnlineDisclaimerFR = this.state.OnlineDisclaimerFR;
        comboModel.OnlineDisclaimerES = this.state.OnlineDisclaimerES;

        var operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SaveCombo_Click);
        operation.AddItem("comboDefinition", comboModel);
        operation.AddItem("isSavingOnlineInfo", true);

        LocalEventDispatcher.dispatch(operation);
    }
}

export { EditOnlineDetailsComponent };
